export function generateColorFromString(str: string): string {
  // Simple hash (no bitwise)
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash + str.charCodeAt(i) * (i + 1)) % 100000;
  }

  // Convert hash → HSL for consistent bright colors
  const hue = hash % 360;
  const saturation = 70; // pretty & readable
  const lightness = 50;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
